const BadgingTabs = ({ activeTab, setActiveTab, isSubAdmin }) => {
  const tabs = [
    { key: 'standistes', label: 'Stand builder' },
    { key: 'contractor', label: 'Contractor' },
    { key: 'staff', label: 'Staff' },
    {key: 'history', label: 'History' },
    { key: 'settings', label: 'Settings' },
  ];

  const visibleTabs = isSubAdmin ? tabs.filter(tab => tab.key !== 'settings') : tabs;

  return (
    <div className="flex gap-2 border-b border-slate-200 mb-6">
      {visibleTabs.map(tab => (
        <button
          key={tab.key}
          onClick={() => setActiveTab(tab.key)}
          className={`px-4 py-2 font-semibold text-sm transition
            ${activeTab === tab.key
              ? 'border-b-2 border-indigo-600 text-indigo-600'
              : 'text-slate-500 hover:text-slate-700'
            }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default BadgingTabs;
